<template>
    <div class="contact-switch-screen">
        <md-progress-bar md-mode="indeterminate" v-if="loading" />
        <div class="toolbar">
            <div class="toolbar-left">
                <i class="material-icons toolbar-back-icon" @click="close">arrow_back</i>
                <span class="toolbar-title">{{ $t("chatWindow.systemStatus") }}</span>
            </div>
            <div class="toolbar-actions">
                <button class="toolbar-btn toolbar-btn-refresh" @click="refresh">
                    <i class="material-icons">refresh</i>
                    <span class="btn-text">{{ $t("chatWindow.refresh") }}</span>
                    <span class="toolbar-shortcut">{{ $t("chatWindow.refreshShortcutKey") }}</span>
                </button>
                <button class="toolbar-btn toolbar-btn-close" @click="close">
                    <i class="material-icons">close</i>
                </button>
            </div>
        </div>

        <div class="summary">
            <div class="summary-card">
                <i class="material-icons card-icon">person</i>
                <div class="card-content">
                    <span class="card-label">{{ $t("chatWindow.totalCustomers") }}</span>
                    <span class="card-value">{{ summary.totalCustomers }}</span>
                </div>
            </div>
            <div class="summary-card">
                <i class="material-icons card-icon">check_circle</i>
                <div class="card-content">
                    <span class="card-label">{{ $t("chatWindow.totalAnswered") }}</span>
                    <span class="card-value">{{ summary.totalAnswered }}</span>
                </div>
            </div>
            <div class="summary-card">
                <i class="material-icons card-icon">description</i>
                <div class="card-content">
                    <span class="card-label">{{ $t("chatWindow.waitingAnswer") }}</span>
                    <span class="card-value">{{ summary.waitingAnswer }}</span>
                </div>
            </div>
            <div class="summary-card">
                <i class="material-icons card-icon">support_agent</i>
                <div class="card-content">
                    <span class="card-label">{{ $t("chatWindow.totalAgentInChat") }}</span>
                    <span class="card-value">{{ summary.totalAgentInChat }}</span>
                </div>
            </div>
            <div class="summary-card summary-card-online">
                <i class="material-icons card-icon">support_agent</i>
                <div class="card-content">
                    <span class="card-label">{{ $t("chatWindow.onlineAgentCount") }}</span>
                    <span class="card-value">{{ summary.onlineAgentCount }}</span>
                </div>
            </div>
        </div>
        <a-divider />
        <div class="agent-filters">
            {{ $t("message.filterBy") }}
            <CircleUserSelect :users="onlineUsers" :value="selectedUserId" @input="changeAgentFilter" nullable />
        </div>
        <a-divider />
        <div class="groups mt-2">
            <ChatGroup v-for="group in groupsByKeys" :key="group" :group="groups[group]"
                :selected-item-id="selectedItemId" :users="users" @watch-all="watchAll(group)"
                @select-customer="select" />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import log2 from "../../../utils/log2";
import { maskContactInfo, isMaskContactInfo } from "../../../utils/utils";
import _ from "lodash";
import moment from "moment/moment";
import AgentAvatar from "../../common/AgentAvatar.vue";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import CircleUserSelect from "./multi-chat-viewer/CircleUserSelect.vue";
import CustomerCard from "./CustomerCard.vue";
import ChatGroup from "./ChatGroup.vue";
import { USER_API } from "../../../api/user";

const log = log2("ContactSwitchScreen");
const createChat = (number) => {
    return {
        _id: number + "66ca105a8e7814a4b7b83395" + Math.floor(Math.random() * 1000),
        users: [["5d14ee322d95ad001ebdf214"], ["6841510676295c70e77ddd41"], []][Math.floor(Math.random() * 3)],
        status: ["active", "chatbot", "new"][Math.floor(Math.random() * 3)],
        answerStatus: ["unanswered", "answered"][Math.floor(Math.random() * 2)],
        createdDate: moment()
            .subtract(Math.floor(Math.random() * 1000 * 60), "ms")
            .toISOString(),
        visitor: {
            _id: "66c5d57d35dfd9fc8422aeec" + Math.floor(Math.random() * 100),
            fullname: "Fatih Bey " + Math.floor(Math.random() * 100),
        },
        connectedUser: ["5d14ee322d95ad001ebdf214", "6841510676295c70e77ddd41", null][Math.floor(Math.random() * 3)],
    };
};
export default Vue.extend({
    name: "ContactSwitchScreen",
    components: { CircleUserSelect, SupsisButton, AgentAvatar, CustomerCard, ChatGroup },
    props: {
        toggleConversation: {
            type: Function,
            default: _.noop,
        },
    },
    computed: {
        ...mapState({
            usersOrdered: (state) => _.orderBy(state.user.users.data, ["name", "status"], ["desc", "asc"]),
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            user: (state) => state.auth.user,
            stats: (state) => state.chat.stats,
            filters: (state) => state.contact.filters,
            cachedContacts: (state) => state.contact.cachedContacts,
            multiChatView: (state) => state.contact.multiChatView,
        }),
        groupsByKeys() {
            return Object.keys(this.groups).filter((key) => (this.selectedUserId ? key === this.selectedUserId : true));
        },
    },
    data() {
        return {
            loading: false,
            selectedGroup: null,
            selectedItemId: null,
            selectedUserId: null,
            onlineUsers: [],
            firstNineItemIds: [],
            groups: {},
            summary: {
                totalCustomers: 0,
                totalInChat: 0,
                totalAnswered: 0,
                waitingAnswer: 0,
            },
        };
    },
    methods: {
        isMaskContactInfo,
        maskField(key, val) {
            return isMaskContactInfo(key) ? maskContactInfo(val) : val;
        },
        ...mapActions({
            setMultiChatView: "contact/setMultiChatView",
            addNewWindow: "app/addNewWindow",
            fetchContact: "contact/fetchContact",
            fetchContacts: "contact/fetchContacts",
        }),
        changeAgentFilter(userId) {
            this.selectedUserId = userId;
        },
        fetchOnlineUsers() {
            USER_API.getOnlineUsers(["_id,name,status"], true, false).then((users) => {
                this.onlineUsers = users
                    .map((user) => {
                        return {
                            user,
                            badge: this.stats.usersChatCounts[user._id] || 0,
                        };
                    })
                    // .filter((x) => {
                    //     if (this.$store.state.auth.user?.role?.isRoot) return true;
                    //     else {
                    //         return x.user._id === this.user._id;
                    //     }
                    // });
            });
        },
        watchAll(type) {
            this.$feature.beforeOpenMultipleChatWindow(() => {
                const contacts = this.groups[type]?.items || [];
                this.setMultiChatView({
                    enabled: true,
                    type: "agent",
                    contacts,
                });
            });
        },
        close() {
            this.$emit("close");
        },
        getSummary(chats) {
            return {
                totalCustomers: chats.length,
                totalAgentInChat: this.groupsByKeys.length,
                totalAnswered: chats.filter((item) => {
                    const answerStatus = item.answerStatus || item.lastConversation?.answerStatus;
                    return answerStatus === "answered";
                }).length,
                waitingAnswer: chats.filter((item) => {
                    const answerStatus = item.answerStatus || item.lastConversation?.answerStatus;
                    return answerStatus !== "answered";
                }).length,
                onlineAgentCount: Object.values(this.users).filter((user) => user.isOnline && user.status === "Online")
                    .length,
            };
        },
        fetchChats(e) {
            if (e) e.stopPropagation();
            const allContactsFilter = this.filters.find((filter) => filter.key === "allContacts");
            this.loading = true;
            const payload = {
                metadata: {
                    source: "ContactSwitchScreen.fetchChats",
                },
                inbox: {
                    type: "system",
                    id: allContactsFilter._id,
                },
                state: "open",
            };
            this.fetchContacts(payload).then((data) => {
                const contacts = data.contacts;
                this.firstNineItemIds = [];
                this.groups = this.getGroups(contacts);
                this.summary = this.getSummary(contacts);
                this.selectedGroup = this.groupsByKeys[0] || null;
                const item = this.groups[this.selectedGroup]?.items?.[0];
                this.selectedItemId = item ? `${item._id}_${item.index}` : null;
            }).finally(() => {
                this.loading = false;
            });
        },
        getGroups(contacts) {
            const result = contacts.reduce(
                (acc, contact) => {
                    // Eski versiyon uyumluluğu için hem yeni hem eski formatı destekle
                    const users = contact.users || contact.lastConversation?.users || [];
                    const connectedUser = contact.connectedUser || contact.lastConversation?.connectedUser;
                    const status = contact.status || contact.lastConversationStatus;

                    let agents = users.length ? users : connectedUser ? [connectedUser] : [null];

                    agents.forEach((agent) => {
                        const group = status === "chatbot" ? "chatbot" : agent || "unassign";
                        if (acc[group]) {
                            // Eski format uyumluluğu için item'ı normalize et
                            const normalizedItem = {
                                ...contact,
                                visitor: contact.visitor || { _id: contact._id, fullname: contact.fullname },
                                createdDate: contact.createdDate || contact.lastConversation?.createdDate,
                                answerStatus: contact.answerStatus || contact.lastConversation?.answerStatus,
                            };
                            acc[group].items.push(normalizedItem);
                        }
                    });
                    return acc;
                },
                {
                    [this.user._id]: {
                        id: this.user._id,
                        agent: this.user._id,
                        items: [],
                    },
                    ...this.usersOrdered
                        .filter((user) => user._id !== this.user._id)
                        .reduce((acc, user) => {
                            acc[user._id] = {
                                id: user._id,
                                agent: user._id,
                                items: [],
                            };
                            return acc;
                        }, {}),
                    unassign: {
                        id: "unassign",
                        agent: "unassign",
                        items: [],
                    },
                    chatbot: {
                        id: "chatbot",
                        agent: "chatbot",
                        items: [],
                    },
                }
            );

            let currIndex = 1;
            Object.values(result).forEach((group) => {
                group.items.forEach((item, index) => {
                    if (currIndex <= 10) {
                        this.firstNineItemIds.push(`${item._id}_${currIndex}`);
                    }
                    result[group.id].items[index].index = currIndex;
                    currIndex = currIndex + 1;
                });
                if (!group.items.length) {
                    delete result[group.id];
                }
            });
            return result;
        },

        async select(item) {
            let contactId = item?.visitor?._id;

            // Eğer item parametresi yoksa, selectedItemId'den item'ı bul
            if (!contactId) {
                const group = this.groups[this.selectedGroup];
                if (group && this.selectedItemId) {
                    const [itemId, itemIndex] = this.selectedItemId.split("_");
                    const foundItem = group.items.find((x) => x._id === itemId && x.index === parseInt(itemIndex));
                    if (foundItem) {
                        contactId = foundItem.visitor?._id || foundItem._id;
                        item = foundItem;
                    }
                }
            }

            if (!contactId && item) {
                contactId = item._id;
            }

            if (contactId) {
                let contact = this.cachedContacts[contactId];
                if (!contact) {
                    contact = await this.fetchContact({ contactId, ignoreSource: "ContactSwitchScreen.select", viewed: true });
                }

                if (contact) {
                    const windows = this.$store.state.app.windows;
                    const windowKeys = Object.keys(windows);
                    const lastWindowKey = windowKeys[windowKeys.length - 1];
                    const lastWindow = windows[lastWindowKey];

                    if (lastWindow && lastWindow.type === "grid-chat-window-contact" &&
                        lastWindow.payload && lastWindow.payload.contactId === contactId) {
                        return;
                    }

                    this.addNewWindow({
                        type: "grid-chat-window-contact",
                        title: contact.fullname || this.maskField('email', contact.email) || this.maskField('phone', contact.phone) || "Bilinmeyen Kişi",
                        autoClose: false,
                        multiple: false,
                        fullShow: true,
                        footer: false,
                        payload: {
                            contactId,
                        },
                    });
                }
            }
        },
        refresh(e) {
            if (e) e.stopPropagation();
            this.fetchChats(e);
            this.fetchOnlineUsers();
        },
    },
    mounted() {
        this.refresh(false);

        const keydownHandler = (e) => {
            const activeElement = document.activeElement;
            const isInputFocused = activeElement && (
                activeElement.tagName === 'INPUT' ||
                activeElement.tagName === 'TEXTAREA' ||
                activeElement.isContentEditable ||
                activeElement.closest('input, textarea, [contenteditable="true"]')
            );

            if (e.key === "ArrowRight") {
                if(isInputFocused) return;
                const currentGroupIndex = this.groupsByKeys.indexOf(this.selectedGroup);
                const currentGroup = this.groups[this.selectedGroup];
                const currentItemIndex = currentGroup.items.findIndex(
                    (item) => `${item._id}_${item.index}` === this.selectedItemId
                );
                if (currentItemIndex === currentGroup.items.length - 1) {
                    this.selectedGroup = this.groupsByKeys[currentGroupIndex + 1] || this.groupsByKeys[0];
                    const item = this.groups[this.selectedGroup]?.items?.[0];
                    this.selectedItemId = item ? `${item._id}_${item.index}` : null;
                } else {
                    const item = currentGroup.items[currentItemIndex + 1];
                    this.selectedItemId = item ? `${item._id}_${item.index}` : null;
                }
            } else if (e.key === "ArrowLeft") {
                if(isInputFocused) return;
                const currentGroupIndex = this.groupsByKeys.indexOf(this.selectedGroup);
                const currentGroup = this.groups[this.selectedGroup];
                const currentItemIndex = currentGroup.items.findIndex(
                    (item) => `${item._id}_${item.index}` === this.selectedItemId
                );
                if (currentItemIndex === 0) {
                    this.selectedGroup =
                        this.groupsByKeys[currentGroupIndex - 1] || this.groupsByKeys[this.groupsByKeys.length - 1];
                    const groupItems = this.groups[this.selectedGroup]?.items || [];
                    const item = groupItems[groupItems.length - 1];
                    this.selectedItemId = item ? `${item._id}_${item.index}` : null;
                } else {
                    const item = currentGroup.items[currentItemIndex - 1];
                    this.selectedItemId = item ? `${item._id}_${item.index}` : null;
                }
            }
            else if (e.key === "r" || e.key === "R") {
                if (this.loading) return;
                this.refresh(false);
            } else if (e.key === "Tab") {
                if (isInputFocused) {
                    return;
                }
                e.preventDefault();

                if (!this.selectedGroup || !this.selectedItemId) {
                    this.selectedGroup = this.groupsByKeys[0];
                    const item = this.groups[this.selectedGroup]?.items?.[0];
                    this.selectedItemId = item ? `${item._id}_${item.index}` : null;
                } else {
                    const currentIndex = this.groupsByKeys.indexOf(this.selectedGroup);
                    this.selectedGroup = this.groupsByKeys[currentIndex + 1] || this.groupsByKeys[0];
                    const item = this.groups[this.selectedGroup]?.items?.[0];
                    this.selectedItemId = item ? `${item._id}_${item.index}` : null;
                }
            } else if (e.key >= "1" && e.key <= "9") {
                if(isInputFocused) return;
                const index = parseInt(e.key);
                if (index <= this.firstNineItemIds.length) {
                    const targetItemId = this.firstNineItemIds[index - 1];
                    this.selectedItemId = targetItemId;

                    // Item'ın hangi grupta olduğunu bul ve selectedGroup'u güncelle
                    const [itemId, itemIndex] = targetItemId.split("_");
                    for (const groupKey of this.groupsByKeys) {
                        const group = this.groups[groupKey];
                        const foundItem = group.items.find((x) => `${x._id}_${x.index}` === targetItemId);
                        if (foundItem) {
                            this.selectedGroup = groupKey;
                            break;
                        }
                    }

                    this.$nextTick(() => {
                        this.select();
                    });
                }
            }
            else if (e.key === "Enter") {
                if (this.multiChatView && this.multiChatView.enabled) {
                    return;
                }

                const windows = this.$store.state.app.windows;
                const windowKeys = Object.keys(windows);
                const lastWindowKey = windowKeys[windowKeys.length - 1];
                const lastWindow = windows[lastWindowKey];

                if (lastWindow && lastWindow.type === "grid-chat-window-contact") {
                    return;
                }

                this.select();
            }
            else if (e.key === "Escape") {
                const modal = document.getElementById('supsis-right-modal');
                if (modal) {
                    // Modal varsa, kısa bir gecikme ile modal kapanmasını bekle
                    setTimeout(() => {
                        const modalCheck = document.getElementById('supsis-right-modal');
                        if (!modalCheck) {
                            // Modal kapandıysa TAB ekranını kapat
                            this.close();
                        }
                        // Modal hala varsa hiçbir şey yapma
                    }, 50);
                    return;
                }
                // Modal yoksa direkt TAB ekranını kapat
                this.close();
            }
        };

        window.addEventListener("keydown", keydownHandler);

        this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("keydown", keydownHandler);
        });
    },
    watch: {
        selectedItemId() {
            const el = this.$el?.querySelector(`.customer-card[item-id="${this.selectedItemId}"]`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },
    },
});
</script>

<style scoped lang="scss">
.contact-switch-screen {
    width: 100%;
    height: 100%;
    overflow: auto;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
    }

    background-color: #fff;
    padding: 10px;
    overflow-y: auto;

    .ant-divider-horizontal {
        margin: 10px 0;
    }

    .agent-filters {
        display: flex;
        gap: 5px;
        align-items: center;
        font-size: 20px;
    }

    .toolbar {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        padding: 16px 20px !important;
        background: #ffffff !important;
        border-bottom: 1px solid #e5e7eb !important;
        margin: -10px -10px 16px -10px !important;
        box-sizing: border-box !important;

        .toolbar-left {
            display: flex !important;
            align-items: center !important;
            gap: 12px !important;

            .toolbar-back-icon {
                font-size: 24px !important;
                color: #374151 !important;
                cursor: pointer !important;
                transition: color 0.2s ease !important;

                &:hover {
                    color: #111827 !important;
                }
            }

            .toolbar-title {
                font-size: 20px !important;
                font-weight: 600 !important;
                color: #111827 !important;
                line-height: 1 !important;
                margin: 0 !important;
            }
        }

        .toolbar-actions {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;

            .toolbar-btn {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                gap: 8px !important;
                height: 40px !important;
                padding: 0 14px !important;
                background: #ffffff !important;
                border: 1px solid #e5e7eb !important;
                outline: none !important;
                border-radius: 12px !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                cursor: pointer !important;
                transition: all 0.2s ease !important;
                box-sizing: border-box !important;
                user-select: none !important;
                white-space: nowrap !important;
                color: #374151 !important;

                .material-icons {
                    font-size: 20px !important;
                    line-height: 1 !important;
                    color: inherit !important;
                }

                &.toolbar-btn-refresh {
                    .btn-text {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                        color: #374151 !important;
                    }

                    .toolbar-shortcut {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        min-width: 24px !important;
                        height: 24px !important;
                        background: #f9fafb !important;
                        border: 1px solid #e5e7eb !important;
                        border-radius: 6px !important;
                        font-size: 12px !important;
                        font-weight: 600 !important;
                        color: #6b7280 !important;
                        padding: 0 6px !important;
                        box-sizing: border-box !important;
                    }

                    &:hover {
                        background: #f9fafb !important;
                        border-color: #d1d5db !important;
                    }

                    &:active {
                        background: #f3f4f6 !important;
                    }
                }

                &.toolbar-btn-close {
                    width: 40px !important;
                    padding: 0 !important;

                    .material-icons {
                        font-size: 20px !important;
                    }

                    &:hover {
                        background: #f9fafb !important;
                        border-color: #d1d5db !important;
                    }

                    &:active {
                        background: #f3f4f6 !important;
                    }
                }
            }
        }
    }

    .summary {
        display: flex !important;
        gap: 12px !important;
        margin-bottom: 16px !important;
        flex-wrap: wrap !important;

        .summary-card {
            flex: 1 !important;
            min-width: 180px !important;
            display: flex !important;
            align-items: flex-start !important;
            gap: 12px !important;
            padding: 16px !important;
            background: #f9fafb !important;
            border-radius: 12px !important;
            box-sizing: border-box !important;
            transition: all 0.2s ease !important;

            &:hover {
                background: #f3f4f6 !important;
            }

            .card-icon {
                font-size: 24px !important;
                color: #9ca3af !important;
                line-height: 1 !important;
                flex-shrink: 0 !important;
                margin-top: 2px !important;
            }

            .card-content {
                display: flex !important;
                flex-direction: column !important;
                gap: 4px !important;
                flex: 1 !important;
                min-width: 0 !important;

                .card-label {
                    font-size: 13px !important;
                    font-weight: 500 !important;
                    color: #6b7280 !important;
                    line-height: 1.4 !important;
                    white-space: nowrap !important;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                }

                .card-value {
                    font-size: 28px !important;
                    font-weight: 700 !important;
                    color: #111827 !important;
                    line-height: 1.2 !important;
                }
            }

            &.summary-card-online {
                background: #f0fdf4 !important;

                &:hover {
                    background: #dcfce7 !important;
                }

                .card-icon {
                    color: #4ade80 !important;
                }

                .card-value {
                    color: #16a34a !important;
                }
            }
        }
    }

    .groups {
        display: flex;
        flex-direction: column;
    }
}
</style>
